import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Obligation from "~/views/obligation"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [{ url: "/bonds/list" }],
    req ? req.headers.host : location.host,
  )
  const crumbs = generateCrumbs(req?.url)
  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Obligation.getInitialProps = getInitialProps

export default Obligation
